<script setup>
/*
    Progress widget

    Components:
        primary: <v-progress-linear>

    Widget Properties:
        value: []

    CSS Properties:
 */
import {reactive, ref} from 'vue'
import {getWidgetProps} from '@/paks/vu-dash/BoardUtils'

defineExpose({update})

const props = defineProps({
    widget: Object,
})

const page = reactive({
    args: {},
    data: {},
    progress: 0,
})

const primary = ref(null)

const DefaultStyles = {
    primary: {
        'color': 'rgb(var(--v-theme-on-primary))',
        'font-size': 'max(10px, min(min(12cqw, 12cqh), 144px))',
        'font-weight': 'bold',
    },
}

function update() {
    let widget = props.widget
    Object.assign(page, getWidgetProps(widget, {primary}, {styles: DefaultStyles}))

    let min = widget.min || 0
    let max = widget.max || 100
    let span = max - min
    page.progress = parseInt(((page.data.primary || 0) / span) * 100)
    page.progress = 55;
    page.args.height = page.styles['.primary.height'] || '25'
}
</script>

<template>
    <v-progress-linear
        class="progress-widget"
        ref="primary"
        v-bind="page.args"
        rounded
        reactive
        color="primary"
        :modelValue="page.progress">
        {{ Math.ceil(page.progress) }}%
    </v-progress-linear>
</template>

<style lang="scss">
.progress-widget {
    margin: 20px;
    align-self: center;
    height: 20cqh !important;
    .v-progress-linear__background {
        opacity: min(calc(var(--v-border-opacity) * 3), 0.5);
    }
}
</style>
